const toFull = (value: string): string => {
  const str = value.replace(/[A-Za-z0-9#$%&\\()*+,.\\/<>\\[\]{}=?|@;:_\\^`]/g, s => {
    return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
  });
  return toFullKana(str);
};
export { toFull };
const toHalf = (value: string): string => {
  const str = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
  return str;
};
export { toHalf };
const toFullKana = str => {
  const kanaMap = {
    ｶﾞ: 'ガ',
    ｷﾞ: 'ギ',
    ｸﾞ: 'グ',
    ｹﾞ: 'ゲ',
    ｺﾞ: 'ゴ',
    ｻﾞ: 'ザ',
    ｼﾞ: 'ジ',
    ｽﾞ: 'ズ',
    ｾﾞ: 'ゼ',
    ｿﾞ: 'ゾ',
    ﾀﾞ: 'ダ',
    ﾁﾞ: 'ヂ',
    ﾂﾞ: 'ヅ',
    ﾃﾞ: 'デ',
    ﾄﾞ: 'ド',
    ﾊﾞ: 'バ',
    ﾋﾞ: 'ビ',
    ﾌﾞ: 'ブ',
    ﾍﾞ: 'ベ',
    ﾎﾞ: 'ボ',
    ﾊﾟ: 'パ',
    ﾋﾟ: 'ピ',
    ﾌﾟ: 'プ',
    ﾍﾟ: 'ペ',
    ﾎﾟ: 'ポ',
    ｳﾞ: 'ヴ',
    ﾜﾞ: 'ヷ',
    ｦﾞ: 'ヺ',
    ｱ: 'ア',
    ｲ: 'イ',
    ｳ: 'ウ',
    ｴ: 'エ',
    ｵ: 'オ',
    ｶ: 'カ',
    ｷ: 'キ',
    ｸ: 'ク',
    ｹ: 'ケ',
    ｺ: 'コ',
    ｻ: 'サ',
    ｼ: 'シ',
    ｽ: 'ス',
    ｾ: 'セ',
    ｿ: 'ソ',
    ﾀ: 'タ',
    ﾁ: 'チ',
    ﾂ: 'ツ',
    ﾃ: 'テ',
    ﾄ: 'ト',
    ﾅ: 'ナ',
    ﾆ: 'ニ',
    ﾇ: 'ヌ',
    ﾈ: 'ネ',
    ﾉ: 'ノ',
    ﾊ: 'ハ',
    ﾋ: 'ヒ',
    ﾌ: 'フ',
    ﾍ: 'ヘ',
    ﾎ: 'ホ',
    ﾏ: 'マ',
    ﾐ: 'ミ',
    ﾑ: 'ム',
    ﾒ: 'メ',
    ﾓ: 'モ',
    ﾔ: 'ヤ',
    ﾕ: 'ユ',
    ﾖ: 'ヨ',
    ﾗ: 'ラ',
    ﾘ: 'リ',
    ﾙ: 'ル',
    ﾚ: 'レ',
    ﾛ: 'ロ',
    ﾜ: 'ワ',
    ｦ: 'ヲ',
    ﾝ: 'ン',
    ｧ: 'ァ',
    ｨ: 'ィ',
    ｩ: 'ゥ',
    ｪ: 'ェ',
    ｫ: 'ォ',
    ｯ: 'ッ',
    ｬ: 'ャ',
    ｭ: 'ュ',
    ｮ: 'ョ',
    '｡': '。',
    '､': '、',
    ｰ: 'ー',
    '｢': '「',
    '｣': '」',
    '･': '・',
    '-': 'ー'
  };
  const reg = new RegExp(`(${Object.keys(kanaMap).join('|')})`, 'g');
  return str.replace(reg, match => kanaMap[match]).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
};

/**
 * メールアドレスが有効な形式かチェックする
 * @param email メールアドレス
 * @return 有効な場合はtrue、それ以外はfalse
 */
export const isValidEmailAddress = (email: string): boolean => {
  if (!email) {
    return false;
  }

  // ローカル部分とドメイン部分が空でない
  const [localPart, domain] = email.split('@');
  if (!localPart || !domain) {
    return false;
  }

  // ローカル部分の先頭が . でない
  if (localPart.startsWith('.')) {
    return false;
  }

  // @ 直前が . でない
  if (localPart.endsWith('.')) {
    return false;
  }

  // ドメイン部分に . が含まれていない
  if (!domain.includes('.')) {
    return false;
  }

  // ドメイン部分の先頭が . でない
  if (domain.startsWith('.')) {
    return false;
  }

  // ドメイン部分の末尾が . でない
  if (domain.endsWith('.')) {
    return false;
  }
  return true;
};